export default __webpack_public_path__ + "static/media/EKYCContinue.a02f3c9f.png";